export default __webpack_public_path__ + "static/teamPhoto5-922882f9d9c85abf0929740e1a253cea.png";